//REFACTOR ALL OF THIS EVENTUALLY INTO A REDUCER, THIS IS NOW HERE BECAUSE WE RELY ON THE CALENDAR
import moment from "moment";
import { updateGlobalErrorMessage } from "../actions/globalError";
import { clone } from "../reducers/helper";
import { updateGlobalSuccessMessage } from "../actions/globalSuccess";
import { customerNotesInitialState } from "../state/initialState";

export function formatPhone(phoneNumber) {
  let formattedPhone = (phoneNumber || "").replace(/[^\d]/g, "");
  if (formattedPhone.length < 11) {
    formattedPhone =
      formattedPhone.substr(0, 3) +
      " " +
      formattedPhone.substr(3, 3) +
      " " +
      formattedPhone.substr(6, 4);
  } else {
    formattedPhone =
      formattedPhone.substr(0, 1) +
      " " +
      formattedPhone.substr(1, 3) +
      " " +
      formattedPhone.substr(4, 3) +
      " " +
      formattedPhone.substr(7, 5);
  }
  if ((phoneNumber || "").indexOf("+") == 0) {
    formattedPhone = "+" + formattedPhone;
  }

  return formattedPhone.trim();
}

export function getRecurringOnTimeItem(startDateAndTime, startTime) {
  let apiFormat =
    moment(startDateAndTime).format("YYYYMMDD") +
    "T" +
    startTime.stringValue +
    "00L";
  let screenFormat =
    moment(startDateAndTime).format("MMM DD, YYYY") +
    "|" +
    startTime.stringValue.substring(0, 2) +
    ":" +
    startTime.stringValue.substring(2, 4);

  return screenFormat + "^" + apiFormat;
}

export function isInternetExplorer() {
  function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }

    var trident = ua.indexOf("Trident/");
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf("rv:");
      return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }

    var edge = ua.indexOf("Edge/");
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
    }

    // other browser
    return false;
  }
  return detectIE();
}
export function getLocalStorageItem(item) {
  let localStorageItem = null;

  if (item) {
    localStorageItem = window.sessionStorage.getItem(item);
  }
  return localStorageItem;
}
export function getSpId() {
  //legacy stuff from the calendar in the background
  return window.SERVICE_PROVIDER_ID;
}
export function getLocationId() {
  //legacy stuff from the calendar in the background
  return window.LOCATION_ID;
}

export function getOrgId() {
  return window.ORG_ID;
}

export const orderServicesInOrderMerchantCreatedInSettingsPages = (
  listOfServices
) => {
  return listOfServices
    .sort((a, b) => {
      if (a.order > b.order) {
        return 1;
      } else if (a.order < b.order) {
        return -1;
      } else {
        return 0;
      }
    })
    .filter((x) => !!x.categories[0])
    .sort((a, b) => {
      if (a.categories[0].order > b.categories[0].order) {
        return 1;
      } else if (a.categories[0].order < b.categories[0].order) {
        return -1;
      } else {
        return 0;
      }
    });
};

export function roundUpDurationInFiveMinutesInterval(initialTime) {
  let time = initialTime;
  if (!time) {
    time = "";
    initialTime = "";
  }
  if (initialTime.split(":").length > 1) {
    //only round up the second half of the initialTime
    time = initialTime.split(":")[1];
  }
  time = parseInt(time, 10);
  if (!isNaN(time) && time > 0) time = Math.ceil(time / 5.0) * 5;
  else if (!isNaN(time) && time < 0) time = Math.floor(time / 5.0) * 5;

  if (initialTime.split(":").length > 1) {
    time = initialTime.split(":")[0] + ":" + time;
  }

  return time;
}

export function parseTimeIntervalIntoMinutesAndHours(userInput) {
  if (!userInput) {
    return userInput;
  }
  let mmHh = "";
  const onlyNums = userInput.replace(/[^\d]/g, "");
  if (userInput.indexOf(":") >= 0) {
    if (
      isNaN(parseInt(userInput.split(":")[0])) ||
      isNaN(parseInt(userInput.split(":")[1]))
    ) {
      mmHh = "00:00";
    } else {
      // User typed hours : minutes
      let hours = parseInt(userInput.split(":")[0]);
      let minutes = parseInt(userInput.split(":")[1]);
      // If minutes is > 60 recalculate the whole thing :-/
      if (minutes > 60) {
        minutes = (hours * 60 + minutes).toString();
        mmHh = convertMinToHhMm(minutes);
      } else {
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        mmHh = hours + ":" + minutes;
      }
    }
  } else {
    // User typed only minutes
    // Converting minutes to hh:mm format
    mmHh = convertMinToHhMm(onlyNums);
  }

  let parseDuration = mmHh === "00:00" ? "" : mmHh;

  return parseDuration;
}

export function convertMinToHhMm(inp) {
  const onlyNums = inp.replace(/[^\d]/g, "");
  if (!onlyNums) {
    return;
  }
  let hours = Math.trunc(onlyNums / 60);
  let minutes = onlyNums % 60;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const output = hours + ":" + minutes;
  return output === "00:00" ? "" : output;
}

export const formatRepeatOnMonthlyUiDate = function (date) {
  let repeatOnObj = {};
  repeatOnObj.date = moment(date._d || date).date();
  repeatOnObj.day = moment(date._d || date).day();
  repeatOnObj.oo = moment(date._d || date).format("Do");

  repeatOnObj.weekOfMonth = function (m) {
    return parseInt((moment(m).date() - 1) / 7) + 1;
  };

  repeatOnObj.nth = function (d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  repeatOnObj.WeekOfMonth = repeatOnObj.weekOfMonth(date._d || date);
  repeatOnObj.Day = moment(date._d || date).format("dddd");

  repeatOnObj.dayOfWeekOfMonth = `${repeatOnObj.WeekOfMonth}${repeatOnObj.nth(
    repeatOnObj.WeekOfMonth
  )}  ${window.APP.LANGUAGE.Pages.AppointmentAdvanced.NthDayOfThemonth.replace(
    "##nth##",
    repeatOnObj.Day
  )}`;

  repeatOnObj.dayOfMonth = `${repeatOnObj.oo} ${window.APP.LANGUAGE.Pages.AppointmentAdvanced.DayOfTheMonth}`;

  return repeatOnObj;
};

export var getParents = function (elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // Set up a parent array
  var parents = [];

  // Push each parent element to the array
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (selector) {
      if (elem.matches(selector)) {
        parents.push(elem);
      }
      continue;
    }
    parents.push(elem);
  }

  // Return our parent array
  return parents;
};

export const decimalPoint = (n) => {
  // adding second decimal 0 if it's missing or .00 if item don't have cents
  if (!n && !(n === 0)) {
    return;
  }
  let nn = n.toString(),
    new_n = nn;

  if (nn.split(".").length == 2) {
    let part1 = nn.split(".")[0];
    let part2 = nn.split(".")[1];
    if (part2.split("").length == 1) {
      new_n = part1 + "." + part2 + "0";
      return new_n;
    }
  } else if (nn.split(".").length == 1) {
    let part1 = nn.split(".")[0];
    new_n = part1 + "." + "00";
    return new_n;
  }

  return new_n;
};

export const convertToCurrency = function (input) {
  let value = new String(input);
  // remove all characters that aren't digit or dot
  value = value.replace(/[^0-9.]/g, "");
  // replace multiple dots with a single dot
  value = value.replace(/\.+/g, ".");
  // only allow 2 digits after a dot
  value = value.replace(/(.*\.[0-9][0-9]?).*/g, "$1");
  // replace multiple zeros with a single one
  value = value.replace(/^0+(.*)$/, "0$1");
  // remove leading zero
  value = value.replace(/^0([^.].*)$/, "$1");
  return value;
};

export function convertDurationApi2ScreenFormat(durationISO) {
  const screenDuration = moment
    .utc(moment.duration(durationISO)._milliseconds)
    .format("HH:mm");
  return screenDuration === "00:00" ? "" : screenDuration;
}

export function convertDurationScreenFormat2Api(userInput) {
  if (!userInput) {
    return userInput;
  }
  let durationISO = userInput;

  if (
    userInput.split(":")[0].toString().length === 2 &&
    userInput.split(":")[1].toString().length === 2
  ) {
    let userInputInMin =
      parseInt(userInput.split(":")[0]) * 60 +
      parseInt(userInput.split(":")[1]);

    durationISO = JSON.parse(
      JSON.stringify({
        duration: moment.duration(userInputInMin, "m"),
      })
    ).duration;
  }
  if (durationISO === "P0D") {
    durationISO = null;
  }
  return durationISO;
}

export function apiLocalTimeToMoment(time) {
  if (!time) {
    return;
  }
  const MM = time.split("T")[0].substring(4, 6);
  const DD = time.split("T")[0].substring(6, 8);
  const YYYY = time.split("T")[0].substring(0, 4);
  const HH = time.split("T")[1].substring(0, 2);
  const mm = time.split("T")[1].substring(2, 4);
  const tempStr = `${MM}-${DD}-${YYYY} ${HH}:${mm}`;

  return moment(tempStr, "MM-DD-YYYY HH:mm");
}

export function isInRange(compareDate, startDate, endDate) {
  return (
    compareDate.isBetween(startDate, endDate, null, "[)") ||
    compareDate.isSame(startDate)
  );
}

export function isInRangeDoesntMatterIfSame(compareDate, startDate, endDate) {
  return compareDate.isBetween(startDate, endDate, null);
}

export function dateRangeOneDay(datePickerDate) {
  //const momentStartDate = datePickerDate2MomentDate(datePickerDate);
  const momentStartDate = datePickerDate;
  let clonedDate = clone(momentStartDate);
  const momentEndDate = moment(clonedDate).add(1, "days");
  const apiStartDate = momentToApi(momentStartDate);
  const apiEndDate = momentToApi(momentEndDate);

  return {
    apiStartDate,
    apiEndDate,
  };
}

export function momentToApi(momentDate) {
  return createApiDate(momentToDateObj(momentDate));
}

export function createApiDate(obj, isUtc = false) {
  const apiDate = `${obj.YYYY}${obj.MM}${obj.DD}T000000${isUtc ? "Z" : "L"}`;

  return apiDate;
}

export function momentToDateObj(date) {
  const formattedMoment = moment(date._d || date).format("YYYY-MM-DDTHH:mm");

  let obj = {
    YYYY: formattedMoment.split("T")[0].substring(0, 4),
    MM: formattedMoment.split("T")[0].substring(5, 7),
    DD: formattedMoment.split("T")[0].substring(8, 10),
  };

  return obj;
}

export function convertApiUtcToLocalMoment(bookingTime, timezone) {
  const MM = bookingTime.split("T")[0].substring(4, 6);
  const DD = bookingTime.split("T")[0].substring(6, 8);
  const YYYY = bookingTime.split("T")[0].substring(0, 4);
  const HH = bookingTime.split("T")[1].substring(0, 2);
  const mm = bookingTime.split("T")[1].substring(2, 4);
  const tempStr = `${MM}-${DD}-${YYYY} ${HH}:${mm}`;

  return moment(moment.utc(tempStr, "MM-DD-YYYY HH:mm")).tz(timezone);
}

export function getSelectedTimePlusDuration(
  selectedDate,
  newSelectedTime,
  timeList,
  totalMinutes
) {
  let newSelectedDate = toApiDateTime(
    selectedDate,
    newSelectedTime.stringValue,
    timeList
  );
  let partlyFormattedDate = `${newSelectedDate.split("T")[0]}T${
    newSelectedTime.stringValue
  }00L`;
  newSelectedDate = apiLocalTimeToMoment(partlyFormattedDate);

  let newSelectedTimePlusDuration = newSelectedDate.add(
    totalMinutes,
    "minutes"
  );

  return newSelectedTimePlusDuration;
}

export function getDateFromString(dateValue) {
  let splitdate = dateValue.split("T");
  return splitdate[0];
}

export function checkIfNewTimeWillCauseDoubleBooking(
  selectedDate,
  selectedTime,
  newSelectedTime,
  totalMinutes,
  timeList,
  timeSlotsContainingAppointments,
  dispatch,
  doubleBookingEnabled,
  unavailableTimeList,
  multiServiceItem,
  selectedStaff
) {
  let newSelectedTimePlusDuration = getSelectedTimePlusDuration(
    selectedDate,
    newSelectedTime,
    timeList,
    totalMinutes
  );
  let timeWillCauseDoubleBooking = false;

  if (!doubleBookingEnabled) {
    return timeWillCauseDoubleBooking;
  }

  //CONTINUE HERE
  //pass dispatch as null so we dont send messages
  let timeIsAcceptable = canUserUseThisTimeDueToDoubleBookingDisabled(
    selectedDate,
    selectedTime,
    newSelectedTime,
    totalMinutes,
    timeList,
    unavailableTimeList,
    null,
    null
  );

  if (timeIsAcceptable) {
    //check for double booking and show message here
    timeSlotsContainingAppointments.forEach((item) => {
      let dateToFindInRange = toApiDateTime(
        selectedDate,
        newSelectedTime.stringValue,
        timeList
      );
      let newDateToFindInRange = toApiDateTime(
        selectedDate,
        newSelectedTime.stringValue,
        timeList
      );
      if (dateToFindInRange && newDateToFindInRange) {
        let partlyFormattedDateFrom = `${dateToFindInRange.split("T")[0]}T${
          item.from.stringValue
        }00L`;
        let fullyFormattedDate = apiLocalTimeToMoment(partlyFormattedDateFrom);
        let selectedDatePlusDuration = `${dateToFindInRange.split("T")[0]}T${
          item.to.stringValue
        }00L`;
        selectedDatePlusDuration = apiLocalTimeToMoment(
          selectedDatePlusDuration
        );

        let newPartlyFormattedDate = `${newDateToFindInRange.split("T")[0]}T${
          newSelectedTime.stringValue
        }00L`;
        let newFullyFormattedDate = apiLocalTimeToMoment(
          newPartlyFormattedDate
        );

        let clashes = false; // we are using the original date, time staff here which will not change on subsequent dropdown changes unlike selecteddate, selectedTime etc.
        let originalDate = toApiDateTime(
          multiServiceItem.originalSelectedDateOnceAppointmentWasOpened,
          multiServiceItem.originalSelectedTimeOnceAppointmentWasOpened
            .stringValue,
          timeList
        );
        let itemDuration = calculateTotalAppointmentDuration(
          multiServiceItem.originalDurationOfFirstAppointmentInRecurringSeries,
          0,
          0,
          0
        );
        itemDuration = itemDuration.split(":");
        let originalMinutes =
          parseInt(itemDuration[0]) * 60 + parseInt(itemDuration[1]);

        let originalTime = moment(originalDate.replace("L", ""));
        let originalTimePlusDuration = moment(originalTime).add(
          originalMinutes,
          "minutes"
        );

        // checking if current time option is in booked out array
        if (
          isInRange(
            newFullyFormattedDate,
            fullyFormattedDate,
            selectedDatePlusDuration
          )
        ) {
          timeWillCauseDoubleBooking = true;
          clashes = isInRange(
            newFullyFormattedDate,
            originalTime,
            originalTimePlusDuration
          ); // clash with ourselves when start time same.
        }

        if (
          isInRangeDoesntMatterIfSame(
            newSelectedTimePlusDuration,
            fullyFormattedDate,
            selectedDatePlusDuration
          ) ||
          isInRangeDoesntMatterIfSame(
            selectedDatePlusDuration,
            newFullyFormattedDate,
            newSelectedTimePlusDuration
          )
        ) {
          timeWillCauseDoubleBooking = true;
          if (!clashes) {
            clashes = isInRangeDoesntMatterIfSame(
              newFullyFormattedDate,
              originalTime,
              originalTimePlusDuration
            ); // clash with ourselves when start time other than same.
          }
        }

        let currentTime = moment(dateToFindInRange.replace("L", ""));
        let currentTimePlusDuration = moment(currentTime).add(
          totalMinutes,
          "minutes"
        );

        //let weAreClashingWithOurselves = isInRangeDoesntMatterIfSame(fullyFormattedDate,currentTime,currentTimePlusDuration)|| isInRangeDoesntMatterIfSame(selectedDatePlusDuration,currentTime,currentTimePlusDuration);
        let weAreClashingWithOurselves =
          clashes ||
          isInRangeDoesntMatterIfSame(
            newSelectedTimePlusDuration,
            originalTime,
            originalTimePlusDuration
          ); //clash with oursleves on endtime

        //this covers future clash with ourselves. check this only when staff or date changes
        if (timeWillCauseDoubleBooking && weAreClashingWithOurselves) {
          if (multiServiceItem && selectedStaff) {
            if (
              multiServiceItem.originalSelectedStaffOnceAppointmentWasOpenedId ==
                selectedStaff.id &&
              getDateFromString(
                multiServiceItem.originalSelectedDateOnceAppointmentWasOpened
              ) == getDateFromString(selectedDate)
            ) {
              timeWillCauseDoubleBooking = false;
            }
          } else {
            timeWillCauseDoubleBooking = false;
          }
        }

        //this covers current clash with ourselves
        if (
          !timeWillCauseDoubleBooking &&
          item.thisIsCurrentAppointmentOriginalStartTime
        ) {
          timeWillCauseDoubleBooking = false;
        }
      }
    });

    if (timeWillCauseDoubleBooking && dispatch) {
      dispatch(
        updateGlobalSuccessMessage({
          message: window.APP.LANGUAGE.Errors.AppointmentAlreadyExistsOnTimeSlot.replace(
            "@@time@@",
            newSelectedTime.value
          ),
          icon: "info_icon",
        })
      );
    }
  }
  return timeWillCauseDoubleBooking;
}

export function canUserUseThisTimeDueToDoubleBookingDisabled(
  selectedDate,
  selectedTime,
  newSelectedTime,
  totalMinutes,
  timeList,
  unavailableTimeList,
  dispatch,
  doubleBookingEnabled
) {
  // looping over time options in dropdown
  let timeIsAcceptable = true;
  let newSelectedTimePlusDuration = getSelectedTimePlusDuration(
    selectedDate,
    newSelectedTime,
    timeList,
    totalMinutes
  );

  unavailableTimeList.forEach((item) => {
    let dateToFindInRange = toApiDateTime(
      selectedDate,
      selectedTime.stringValue,
      timeList
    );
    let newDateToFindInRange = toApiDateTime(
      selectedDate,
      newSelectedTime.stringValue,
      timeList
    );
    if (dateToFindInRange && newDateToFindInRange) {
      let partlyFormattedDateFrom = `${dateToFindInRange.split("T")[0]}T${
        item.from.stringValue
      }00L`;
      let fullyFormattedDate = apiLocalTimeToMoment(partlyFormattedDateFrom);
      let selectedDatePlusDuration = `${dateToFindInRange.split("T")[0]}T${
        item.to.stringValue
      }00L`;
      selectedDatePlusDuration = apiLocalTimeToMoment(selectedDatePlusDuration);

      let newPartlyFormattedDate = `${newDateToFindInRange.split("T")[0]}T${
        newSelectedTime.stringValue
      }00L`;
      let newFullyFormattedDate = apiLocalTimeToMoment(newPartlyFormattedDate);

      // checking if current time option is in booked out array
      if (
        isInRangeDoesntMatterIfSame(
          newFullyFormattedDate,
          fullyFormattedDate,
          selectedDatePlusDuration
        )
      ) {
        timeIsAcceptable = false;
      }

      if (
        isInRangeDoesntMatterIfSame(
          newSelectedTimePlusDuration,
          fullyFormattedDate,
          selectedDatePlusDuration
        )
      ) {
        timeIsAcceptable = false;
      }

      let currentTime = moment(dateToFindInRange.replace("L", ""));
      let currentTimePlusDuration = moment(currentTime).add(
        totalMinutes,
        "minutes"
      );
      let weAreClashingWithOurselves =
        isInRangeDoesntMatterIfSame(
          fullyFormattedDate,
          currentTime,
          currentTimePlusDuration
        ) ||
        isInRangeDoesntMatterIfSame(
          selectedDatePlusDuration,
          currentTime,
          currentTimePlusDuration
        );

      //this covers future clash with ourselves
      if (
        !timeIsAcceptable &&
        weAreClashingWithOurselves &&
        doubleBookingEnabled == false
      ) {
        // we check doubleBookingEnabled because it would mean we can only clash with ourselves
        timeIsAcceptable = true;
      }

      //this covers current clash with ourselves
      if (
        !timeIsAcceptable &&
        item.thisIsCurrentAppointmentOriginalStartTime &&
        doubleBookingEnabled == false
      ) {
        // we check doubleBookingEnabled because it would mean we can only clash with ourselves
        timeIsAcceptable = true;
      }
    }
  });

  if (!timeIsAcceptable && dispatch) {
    dispatch(
      updateGlobalErrorMessage(
        window.APP.LANGUAGE.Errors.ParticularTimeIsInvalid.replace(
          "@@time@@",
          newSelectedTime.value
        )
      )
    );
  }
  return timeIsAcceptable;
}

export function datePickerDateToMomentDate(datePickerDate) {
  // react-date-picker returns date in doggy moment format so we have to build valid moment
  const _datePickerDate = datePickerDate.format("YYYY-MM-DDTHH:mm");
  const MM = _datePickerDate.split("T")[0].substring(5, 7);
  const DD = _datePickerDate.split("T")[0].substring(8, 10);
  const YYYY = _datePickerDate.split("T")[0].substring(0, 4);
  const HH = "00";
  const mm = "00";

  const tempStr = `${MM}-${DD}-${YYYY} ${HH}:${mm}`;

  const momentDate = moment(tempStr, "MM-DD-YYYY HH:mm"); //.tz(window.timezone.id);

  return momentDate;
}

export function addMultipleAppointmentDurations(durations) {
  let calculateDurations = (duration = 0, durationIndex) => {
    if (durationIndex == durations.length) return duration;
    return calculateDurations(
      duration +
        moment.duration(durations[durationIndex])._milliseconds / 1000 / 60,
      durationIndex + 1
    );
  };

  let totalMinutes = calculateDurations(0, 0);

  let minutes = totalMinutes % 60,
    hours = Math.floor(totalMinutes / 60),
    timePrint = "";

  if (minutes > 60) {
    timePrint = `${hours}:${minutes}`;
  } else if (hours == 0) {
    timePrint = `00:${minutes}`;
  } else {
    if (minutes == 0) {
      timePrint = `${hours}:00`;
    } else {
      timePrint = `${hours}:${minutes}`;
    }
  }
  if (hours < 10 && hours > 0) {
    timePrint = "0" + timePrint;
  }
  if (timePrint == "0") {
    timePrint = "00:00";
  }

  return timePrint;
}

export function calculateTotalAppointmentDuration(
  appointmentDuration,
  splitAppointmentFreeTime,
  splitAppointmentFinishTime,
  splitAppointmentBufferTime
) {
  let totalMinutes =
    moment.duration(appointmentDuration)._milliseconds / 1000 / 60 +
    moment.duration(splitAppointmentFreeTime)._milliseconds / 1000 / 60 +
    moment.duration(splitAppointmentFinishTime)._milliseconds / 1000 / 60 +
    moment.duration(splitAppointmentBufferTime)._milliseconds / 1000 / 60;

  let minutes = totalMinutes % 60,
    hours = Math.floor(totalMinutes / 60),
    timePrint = "";

  if (minutes > 60) {
    timePrint = `${hours}:${minutes}`;
  } else if (hours == 0) {
    timePrint = `00:${minutes}`;
  } else {
    if (minutes == 0) {
      timePrint = `${hours}:00`;
    } else {
      timePrint = `${hours}:${minutes}`;
    }
  }
  if (hours < 10 && hours > 0) {
    timePrint = "0" + timePrint;
  }
  if (timePrint == "0") {
    timePrint = "00:00";
  }
  return timePrint;
}
export let convertDateTimeFromApi = (selectedDateTime) => {
  return (
    moment(selectedDateTime).format("YYYY") +
    "-" +
    moment(selectedDateTime).format("MM") +
    "-" +
    moment(selectedDateTime).format("DD") +
    "T" +
    moment(selectedDateTime).format("HH:mm")
  );
};

export let convertTimeFromApi = (selectedTime) => {
  let timeValue = moment(selectedTime).format("hh:mm a");
  if (timeValue.indexOf("0") == 0) {
    timeValue = timeValue.replace("0", "");
  }
  return {
    value: timeValue,
    stringValue: moment(selectedTime).format("HHmm"),
    selected: false,
    disabled: false,
  };
};

export let getFinalListOfServicesWithAccessAndNoAccess = (
  listOfServices,
  sibblingBookingsTotalStartingFromZero
) => {
  let indexes = listOfServices.map((x) => {
    return x.indexAmongstSibblings; //create list of indexes to find out the missing ones
  });
  indexes.sort();
  if (listOfServices.length !== sibblingBookingsTotalStartingFromZero) {
    //DES-751 discard the cancelled appt scenario here.
    for (let i = 1; i < sibblingBookingsTotalStartingFromZero + 1; i++) {
      // find missing indexes which are services we dont have access to
      if (indexes.indexOf(i) > -1) {
        //do nothing
      } else {
        indexes.push(i);
      }
    }
    indexes.sort();
  }

  let resultingList = [];
  indexes.forEach((i) => {
    let serviceWithCurrentIndex = listOfServices.find(
      (x) => x.indexAmongstSibblings == i
    );
    if (!serviceWithCurrentIndex) {
      resultingList.push({
        noAccess: true,
      });
    } else {
      resultingList.push(serviceWithCurrentIndex);
    }
  });
  return resultingList;
};

function hours12to24(h, pm) {
  return h == 12 ? (pm ? 12 : 0) : pm ? h + 12 : h;
}

function hours24to12(h) {
  return {
    hour: ((h + 11) % 12) + 1,
    pm: h >= 12,
  };
}

export function getAmPmTime(time = "0:00") {
  // if (time.indexOf('0') > -1 && time.indexOf('0') < 2 && time.indexOf(':') > 0) {
  //   time = time.split(':')[1] + ':' + time.split(':')[0]; //reverse because we prefer hours instead of minutes on left hand side
  // }

  let hourFactor = time.split(":")[0];
  let parsedHour = parseInt(hourFactor || 0, 10);
  if (parsedHour > 24) parsedHour = 24;
  else if (parsedHour < 0) parsedHour = 0;

  let h = hours24to12(parsedHour);

  let minutes = time.split(":")[1];
  if (minutes) minutes = ":" + minutes;
  else minutes = "";

  return h.hour + minutes + (h.pm ? " pm" : " am");
}

export function get24sTime(time) {
  let hour = time.split(":")[0];
  let pm = time.indexOf("pm") > -1;
  hour = parseInt(hour, 10);
  let minutes = (time.split(":")[1] || "").split(" ")[0];

  if (pm) {
    hour += 12;
  }
  return (hour == 12 ? (pm ? 12 : 0) : hour) + minutes;
}

export function toApiDateTime(date, time, timeList) {
  if (!date.isValid) {
    // this means the object lost some properties
    date = moment(date._d || date);
  }
  const tmp = timeList.find((t) => t.stringValue === time);
  if (!tmp) {
    return;
  }

  let daTime = tmp.stringValue;
  return `${date.format("YYYYMMDD")}T${daTime}00L`;
}

export function toSpecificApiDateTime(date) {
  if (!date.isValid) {
    // this means the object lost some properties
    date = moment(date._d || date);
  }

  return `${date.format("YYYYMMDD")}T${date.format("HHmm")}00L`;
}

export function getDateInATimeZone(timezone) {
  try {
    let today = new Date().toLocaleString("en-US", { timeZone: timezone });
    let dayWrapper = moment(today).format("YYYYMMDD[T]HHmm[00L]");

    let convertedDay = convertApiUtcToLocalMoment(dayWrapper, timezone);
    return convertedDay;
  } catch (ex) {
    return new Date();
  }
}

export const deepDiffMapper = (function () {
  return {
    VALUE_CREATED: "created",
    VALUE_UPDATED: "updated",
    VALUE_DELETED: "deleted",
    VALUE_UNCHANGED: "unchanged",
    map: function (obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw "Invalid argument. Function given, object expected.";
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        return {
          type: this.compareValues(obj1, obj2),
          data: obj1 === undefined ? obj2 : obj1,
        };
      }

      var diff = {};
      for (var key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        var value2 = undefined;
        if ("undefined" != typeof obj2[key]) {
          value2 = obj2[key];
        }

        diff[key] = this.map(obj1[key], value2);
      }
      for (var key in obj2) {
        if (this.isFunction(obj2[key]) || "undefined" != typeof diff[key]) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;
    },
    compareValues: function (value1, value2) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (
        this.isDate(value1) &&
        this.isDate(value2) &&
        value1.getTime() === value2.getTime()
      ) {
        return this.VALUE_UNCHANGED;
      }
      if ("undefined" == typeof value1) {
        return this.VALUE_CREATED;
      }
      if ("undefined" == typeof value2) {
        return this.VALUE_DELETED;
      }

      return this.VALUE_UPDATED;
    },
    isFunction: function (obj) {
      return {}.toString.apply(obj) === "[object Function]";
    },
    isArray: function (obj) {
      return {}.toString.apply(obj) === "[object Array]";
    },
    isDate: function (obj) {
      return {}.toString.apply(obj) === "[object Date]";
    },
    isObject: function (obj) {
      return {}.toString.apply(obj) === "[object Object]";
    },
    isValue: function (obj) {
      return !this.isObject(obj) && !this.isArray(obj);
    },
  };
})();

export function overlaps(
  firstStartTime,
  firstEndTime,
  secondStartTime,
  secondEndTime
) {
  return (
    (firstStartTime.isBefore(secondEndTime) &&
      secondStartTime.isBefore(firstEndTime)) ||
    (secondStartTime.isBefore(firstEndTime) &&
      firstStartTime.isBefore(secondEndTime))
  );
}

// Disables all timeslots which overlap with an existing booking
// Disables all timeslots which the current booking start time cannot be set to
// Disables all timeslots for multiservice appointments apart from the start time of the last multi service appointment
export function updateDisabledInTimeList(
  timeList,
  selectedDate,
  bookings,
  item,
  multiServiceList
) {
  bookings.forEach((booking) => {
    timeList.forEach((timeListItem, i) => {
      let formattedTimeSlot = `${selectedDate.split("T")[0]}T${
        timeListItem.stringValue
      }00L`;
      let timeSlot = apiLocalTimeToMoment(formattedTimeSlot);
      const bookingLocalStartTime = apiLocalTimeToMoment(
        booking.localstarttime
      );
      const bookingLocalEndTime = apiLocalTimeToMoment(booking.localendtime);
      const multiServiceListItem = multiServiceList
        ? multiServiceList.find((service) => service.id === item.id) || item
        : item;
      const appointmentDuration = multiServiceListItem.appointmentDuration;
      let appointmentDurationInMin =
        parseInt(appointmentDuration.split(":")[0]) * 60 +
        parseInt(appointmentDuration.split(":")[1]);
      const currentAppointmentStartTime = apiLocalTimeToMoment(
        `${selectedDate.split("T")[0]}T${
          multiServiceListItem.selectedTime.stringValue
        }00L`
      );
      const currentAppointmentEndTime = multiServiceListItem
        .appointmentEndTimeFromApi.stringValue
        ? apiLocalTimeToMoment(
            `${selectedDate.split("T")[0]}T${
              multiServiceListItem.appointmentEndTimeFromApi.stringValue
            }00L`
          )
        : currentAppointmentStartTime
            .clone()
            .add(appointmentDurationInMin, "m");
      const isCurrentDay = moment(
        multiServiceListItem.originalSelectedDateOnceAppointmentWasOpened ||
          item.selectedDate
      ).isSame(apiLocalTimeToMoment(selectedDate), "day");
      // If the current appointment is not on the same day as the selectedDate, don't need to do any checks around multi service, as we treat them as regular appointments
      const hasMultiService =
        multiServiceList && isCurrentDay ? multiServiceList.length > 1 : 0;

      let lastMultiServiceAppointment;
      let lastMultiServiceAppointmentEndTime;
      let isMultiServiceAppointment = false;

      // If there are multi service appointments get the last one
      if (hasMultiService) {
        multiServiceList.forEach((multiServiceAppointment) => {
          if (!lastMultiServiceAppointment) {
            lastMultiServiceAppointment = multiServiceAppointment;
          } else if (
            moment(lastMultiServiceAppointment.selectedDate).isBefore(
              moment(multiServiceAppointment.selectedDate)
            )
          ) {
            lastMultiServiceAppointment = multiServiceAppointment;
          }

          const currentMultiServiceStartTime = apiLocalTimeToMoment(
            `${selectedDate.split("T")[0]}T${
              multiServiceAppointment.selectedTime.stringValue
            }00L`
          );
          const currentMultiServiceEndTime = apiLocalTimeToMoment(
            `${selectedDate.split("T")[0]}T${
              multiServiceAppointment.appointmentEndTimeFromApi.stringValue
            }00L`
          );

          // If a multiservice appointment overlaps with the booking, then the booking is a multiservice booking,
          // and if the multiservice appointment is the currently selected booking don't disable timeslot
          if (
            overlaps(
              bookingLocalStartTime,
              bookingLocalEndTime,
              currentMultiServiceStartTime,
              currentMultiServiceEndTime
            ) &&
            overlaps(
              timeSlot,
              timeSlot.clone().add(appointmentDurationInMin, "m"),
              bookingLocalStartTime,
              bookingLocalEndTime
            ) &&
            overlaps(
              currentAppointmentStartTime,
              currentAppointmentEndTime,
              currentMultiServiceStartTime,
              currentMultiServiceEndTime
            )
          ) {
            isMultiServiceAppointment = true;
          }
        });

        lastMultiServiceAppointmentEndTime = apiLocalTimeToMoment(
          `${moment(lastMultiServiceAppointment.selectedDate).format(
            "YYYYMMDD"
          )}T${
            lastMultiServiceAppointment.appointmentEndTimeFromApi.stringValue
          }00L`
        );
      }

      // Timeslot is same as starttime of currently selected appointment
      if (timeSlot.isSame(currentAppointmentStartTime) && isCurrentDay) {
        timeListItem.thisIsCurrentAppointmentOriginalStartTime = true;
      } else {
        delete timeListItem.thisIsCurrentAppointmentOriginalStartTime;
      }

      // If timeslot is for last multi service appointment
      // and is the start time of the multi service appointment, do nothing as there is a check in the component
      if (
        lastMultiServiceAppointment &&
        isInRange(
          timeSlot,
          moment(lastMultiServiceAppointment.selectedDate),
          lastMultiServiceAppointmentEndTime
        ) &&
        timeSlot.isSame(moment(lastMultiServiceAppointment.selectedDate))
      ) {
        // do nothing
      }
      // If the timeslot is a during a multiservice appointment and the current selected appointment is in the group, then disable timeslot
      // This doesn't disable timeslots before a multiservice appointment, as this will happen in the component
      else if (
        isMultiServiceAppointment &&
        isInRange(timeSlot, bookingLocalStartTime, bookingLocalEndTime)
      ) {
        timeListItem.disabled = true;
      }
      // If the appointment was to start at the current timeslot and overlaps with an existing booking
      // and doesn't overlap with the currently selected appointment it is overlapping with one of the bookings
      // or is a different day disable timeslot
      else if (
        !isMultiServiceAppointment &&
        // Check if the appointment was at the timeslot, and would overlap an existing booking
        overlaps(
          timeSlot,
          timeSlot.clone().add(appointmentDurationInMin, "m"),
          bookingLocalStartTime,
          bookingLocalEndTime
        )
      ) {
        // If first booking and timeslot is before bookingLocalStartTime
        if (
          currentAppointmentStartTime.isSame(bookingLocalStartTime) &&
          timeSlot.isBefore(bookingLocalStartTime) &&
          isCurrentDay
        ) {
          // do nothing
          // If timeslot is the start of selected booking
        } else if (
          currentAppointmentStartTime.isSame(timeSlot) &&
          isCurrentDay
        ) {
          // do nothing
          // If last booking and timeslot is within the booking
        } else if (
          currentAppointmentEndTime.isSame(bookingLocalEndTime) &&
          timeSlot.isAfter(currentAppointmentStartTime) &&
          timeSlot.isBefore(currentAppointmentEndTime) &&
          isCurrentDay
        ) {
          // do nothing
        } else {
          timeListItem.disabled = true;
        }
      } else if (
        // If the appointment was to start at the current timeslot and isn't the same start / end time as the currently selected appointment (selecting the original timeslot)
        // and the appointment is smaller than the booking in the timeslot
        // it is trying to overlap back to back appointments so disable timeslot
        !isMultiServiceAppointment &&
        !timeSlot.isSame(currentAppointmentStartTime) &&
        !timeSlot
          .clone()
          .add(appointmentDurationInMin, "m")
          .isSame(currentAppointmentEndTime) &&
        timeSlot.isAfter(bookingLocalStartTime) &&
        timeSlot
          .clone()
          .add(appointmentDurationInMin, "m")
          .isBefore(bookingLocalEndTime)
      ) {
        timeListItem.disabled = true;
      }
    });
  });

  return timeList;
}
